var _style, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "russia-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f5f5f5 } \n\t\t.s1 { fill: #ff4b55 } \n\t\t.s2 { fill: #41479b } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 0h20v6.7h-20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 13.3h20v6.7h-20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m0 6.7h20v6.6h-20z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.ddd4471da7f38288accd49d8d81a2405.svg";
export { ForwardRef as ReactComponent };